import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { articles, hotArticles } from "@/utils/content";

export default function HomeNews() {
  const latest = articles.slice(0, 6);
  const hot = hotArticles(5);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20" id="latest">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Today's Feed"
          title="今日吃瓜快讯"
          description="把最值得知道的新鲜瓜整理成短篇，三分钟看完一整个来龙去脉。"
          action={
            <Link
              to="/news"
              className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
            >
              查看全部快讯 <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-8">
            {latest.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-32 rounded-lg border border-background-200 bg-background-100/70 p-5">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                  <i className="ri-fire-fill text-primary-500"></i> 瓜田热榜
                </h3>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800">
                  实时
                </span>
              </div>
              <ol className="mt-5 space-y-4">
                {hot.map((article, index) => (
                  <li key={article.id} className="flex items-start gap-3">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        index < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-300 text-foreground-700"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <div className="min-w-0">
                      <Link
                        to={`/article/${article.id}`}
                        className="line-clamp-2 text-sm font-medium leading-relaxed text-foreground-800 transition-colors hover:text-primary-700"
                      >
                        {article.title}
                      </Link>
                      <p className="mt-1 text-xs text-foreground-500">
                        {article.topicName} · {article.views} 阅读
                      </p>
                    </div>
                  </li>
                ))}
              </ol>
              <Link
                to="/news"
                className="mt-6 flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                更多热榜 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}